import { ResponsiveFlex, UI, Stack } from '@genial/components';
import React from 'react';
export interface ConfirmationButtonProps {
  onConfirm: () => void;
  disabled?: boolean;
  buttonText?: string;
  disabledReason?: string;
  flex?: ResponsiveFlex;
}

export const ConfirmationButton: React.FC<ConfirmationButtonProps> = ({
  onConfirm,
  disabled = false,
  buttonText = 'Continuar',
  disabledReason,
  flex,
}) => {
  const button = (
    <UI.Button flex={flex} variant="primary" onPress={onConfirm} isDisabled={disabled}>
      {buttonText}
    </UI.Button>
  );

  if (disabledReason && disabled) {
    return (
      <UI.Tooltip label={disabledReason}>
        <Stack>{button}</Stack>
      </UI.Tooltip>
    );
  }

  return button;
};
